<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />

          {{ /* table controllers */ }}
          <div>
            <div class="form-group form-inline pull-left mb-2">
              <b-btn href size="sm" @click="sync()" class="vgt-left-btn">
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </b-btn>
              &nbsp;
              <!-- <b-btn
                class="datepicker-button vgt-left-btn"
                size="sm"
                @click="$refs.datePicker.toggleCalendar()"
              >Date</b-btn>
              <DateRangePicker
                ref="datePicker"
                @selected="onVGTDateRangeSelected"
                i18n="EN"
                :captions="{'title': 'Choose Dates', 'ok_button': 'Apply'}"
                :presetRanges="datePresetRanges"
              ></DateRangePicker>
              &nbsp; -->
              <b-btn
                class="vgt-left-btn"
                target="_blank"
                href="/guides/Delivery Guarantee Claims Form.pdf"
                size="sm"
              >Download PB Claim Form</b-btn>
              &nbsp;
              <b-btn
                class="vgt-left-btn"
                size="sm"
                target="_blank"
                href="https://www.pitneybowes.com/us/shipping-and-mailing/ecommerce/delivery-services/delivery-guarantee/3-day-guaranteed-delivery.html"
              >PB Terms & Conditions</b-btn>
              &nbsp;
              <template
                v-if="tab == 'claimable'"
              >
                <b-btn
                  :disabled="serverParams.ids.length < 1"
                  class="vgt-left-btn vgt-red"
                  size="sm"
                  @click="exportClaim"
                >Export</b-btn>
                &nbsp;
              </template>
              <b-btn
                :disabled="serverParams.ids.length < 1"
                class="vgt-left-btn vgt-red"
                size="sm"
                @click="hideClaims"
              >Delete</b-btn>
              &nbsp;
            </div>

            <div class="form-group form-inline pull-right mb-2">
              <b-input-group>
                <b-input class="table-search border-right-0 border" v-model="searchkw" size="sm" placeholder="Search" @keypress.enter="onTableSearch"/>
                <b-input-group-append>
                  <b-button
                    variant="outline-error"
                    class="border-left-0 border"
                    @click="onVGTClearSearch"
                  >
                    <i :class="['fa', 'fa-times', {'opacity-0': !searchkw}]"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-btn variant="success" @click="onTableSearch">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
              &nbsp;
              <b-dropdown id="dropdown-1" text="Edit Columns" class="vgt-right-btn" size="sm">
                <b-dropdown-form style="padding-left: 0.5rem">
                  <b-form-checkbox-group v-model="selectedColumns">
                    <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                      {{ col.label }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <b-dropdown-item-button @click="onVGTColumnSelect">
                    <b-button size="sm" block class="vgt-right-btn">Apply</b-button>
                  </b-dropdown-item-button>
                </b-dropdown-form>
              </b-dropdown>
              &nbsp;
              <!-- <b-button size="sm" @click="exportClaim" class="vgt-right-btn">
                Export Data
                <span class="glyphicon glyphicon-download-alt"></span>
              </b-button> -->
            </div>
          </div>
          {{ /* table controllers */ }}

          <div class="clearfix"></div>

          <p class="guaranteed-verbage">
            Shipments will auto delete after 90 days from label created date
          </p>

          <b-tabs>
            <b-tab @click="getOrders(true)">
              <template slot="title">
                Claimable ({{ claimable }})
              </template>
              <b-row class="justify-content-end">
                <b-col sm="auto" style="z-index: 999;">
                  <b-input-group class="mb-2">
                    <div class="db-help import">
                      <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
                        <template slot="button-content">
                          <b-img src="/images/icons/information.png" />
                        </template>
                        <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
                          <ul>
                            <li>Maximum selected records is {{ serverParams.perPage }}</li>
                            <li>Records selected has to be within the current table</li>
                          </ul>
                        </b-dropdown-text>
                      </b-dropdown>
                    </div>
                    <b-form-input
                      class="table-search border-right-0 border"
                      size="sm"
                      v-model="customRange"
                      placeholder="Custom Range (e.g. 1-5, 10)"
                      style="width: 200px;"
                      @keyup.enter="customSelectedRows"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-error"
                        class="border-left-0 border"
                        @click="(e) => {
                          if(customRange) {
                            customRange = '';
                          }
                        }"
                      >
                        <i :class="['fa', 'fa-times', {'opacity-0': !customRange}]"></i>
                      </b-button>
                    </b-input-group-append>
                    <b-input-group-append>
                      <b-btn variant="success" @click="customSelectedRows">Go</b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>

              {{ /* VGT */ }}
              <vue-good-table
                ref="vgt"
                mode="remote"
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table striped bordered condensed"
                max-height="70vh"
                :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
                :search-options="{ enabled: true, externalQuery: searchTerm }"
                :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPage: serverParams.perPage, perPageDropdown: [50, 100, 250], dropdownAllowAll: false }"
                :totalRows="totalRecords"
                :line-numbers="true"
                :row-style-class="rowStyleClass"
                @on-search="onVGTSearch"
                @on-selected-rows-change="onVGTSelected"
                @on-row-dblclick="onVGTDoubleClick"
                @on-page-change="onVGTPageChange"
                @on-sort-change="onVGTSortChange"
                @on-column-filter="onVGTColumnFilter"
                @on-per-page-change="onVGTPerPageChange"
              >
                <div slot="emptystate"> N/A </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'id'">
                    <b-form-checkbox
                      :id="props.row.id + '-checkbox'"
                      :checked="props.row.label_claimed"
                      :value="props.row.label_claimed ? 1 : ''"
                      :disabled="checkClaim(props.row)"
                    ></b-form-checkbox>
                  </span>
                  <span v-else-if="props.column.field === 'marketplace' ">
                    <img
                      v-if="props.row.marketplace"
                      :src="props.row.marketplace.img"
                      class="img-responsive"
                    />
                    <span v-else>.</span>
                  </span>
                  <span v-else-if="props.column.field === 'status'">
                    {{ $t(props.row.status)}}
                    <span style="display:none;">
                      {{ $t(props.row.uid)}}:
                      {{ $t(props.row.id)}}
                    </span>
                  </span>
                  <span v-else-if="['created_at', 'acceptance_date', 'delivered_date', 'postmark_date'].includes(props.column.field)">
                    {{ props.row[props.column.field]|utcDate("MMM DD YYYY") }}
                  </span>
                  <span v-else-if="props.column.field === 'days_in_transit'">
                    <span v-html="getTransitDays(props.row).html"></span>
                  </span>
                  <span v-else-if="props.column.field === 'address'">
                    {{ props.row.address.address1}} <br />
                    {{ props.row.address.address2}} <br />
                    {{ props.row.address.address3}}
                  </span>
                  <span v-else-if="props.column.field === 'name'">
                    <span v-if="props.row.name.name.trim()">
                      {{ props.row.name.name }} <br />
                    </span>
                    {{ props.row.name.company }}
                  </span>
                  <span v-else-if="props.column.field === 'confirmation'">
                    {{ getSignatureName(props.row) }}
                  </span>
                  <span v-else-if="props.column.field === 'tracking_id'">
                    <a :href="props.row.tracking_id.target" target="_blank" >{{ props.row.tracking_id.id }}</a>
                  </span>
                  <span v-else-if="['declared_value', 'rate', 'insurance_price','total_price', 'tracking_price'].includes(props.column.field)">
                    {{ format.price(props.row[props.column.field]) }}
                  </span>
                  <span v-else-if="props.column.field === 'total_weight'">
                    {{getWeight(props.row.total_weight).lb}}lb
                    {{getWeight(props.row.total_weight).oz}}oz
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>

              </vue-good-table>
              {{ /* VGT */ }}
            </b-tab>
            <b-tab @click="getOrders(false)">
              <template slot="title">
                All Shipments ({{ shipments }})
              </template>
              {{ /* VGT */ }}
              <div style="height: 30px!important"></div>
              <vue-good-table
                ref="vgt"
                mode="remote"
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table striped bordered condensed"
                max-height="70vh"
                :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
                :search-options="{ enabled: true, externalQuery: searchTerm }"
                :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPage: serverParams.perPage, perPageDropdown: [50, 100, 250], dropdownAllowAll: false }"
                :totalRows="totalRecords"
                :line-numbers="true"
                @on-search="onVGTSearch"
                @on-selected-rows-change="onVGTSelected"
                @on-row-dblclick="onVGTDoubleClick"
                @on-page-change="onVGTPageChange"
                @on-sort-change="onVGTSortChange"
                @on-column-filter="onVGTColumnFilter"
                @on-per-page-change="onVGTPerPageChange"
              >
                <div slot="emptystate"> N/A </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'id'">
                    <span v-if="props.row.label_claimed">
                      Yes
                    </span>
                    <span v-else>
                      No
                    </span>
                    <!-- <b-form-checkbox
                      :id="props.row.id + '-checkbox'"
                      :checked="props.row.label_claimed"
                      :value="props.row.label_claimed ? 1 : ''"
                      :disabled="checkClaim(props.row)"
                      @change="claimLabel(props.row)"
                    ></b-form-checkbox> -->
                  </span>
                  <span v-else-if="props.column.field === 'marketplace' ">
                    <img
                      v-if="props.row.marketplace"
                      :src="props.row.marketplace.img"
                      :height="props.row.marketplace.height"
                      :width="props.row.marketplace.weight"
                      class="img-responsive"
                    />
                    <span v-else>.</span>
                  </span>
                  <span v-else-if="props.column.field === 'status'">
                    {{ $t(props.row.status)}}
                    <span style="display:none;">
                      {{ $t(props.row.uid)}}:
                      {{ $t(props.row.id)}}
                    </span>
                  </span>
                  <span v-else-if="['created_at', 'acceptance_date', 'delivered_date', 'postmark_date'].includes(props.column.field)">
                    {{ props.row[props.column.field]|utcDate("MMM DD YYYY") }}
                  </span>
                  <span v-else-if="props.column.field === 'days_in_transit'">
                    <span v-html="getTransitDays(props.row).html"></span>
                  </span>
                  <span v-else-if="props.column.field === 'address'">
                    {{ props.row.address.address1}} <br />
                    {{ props.row.address.address2}} <br />
                    {{ props.row.address.address3}}
                  </span>
                  <span v-else-if="props.column.field === 'name'">
                    <span v-if="props.row.name.name.trim()">
                      {{ props.row.name.name }} <br />
                    </span>
                    {{ props.row.name.company }}
                  </span>
                  <span v-else-if="props.column.field === 'confirmation'">
                    {{ getSignatureName(props.row) }}
                  </span>
                  <span v-else-if="props.column.field === 'tracking_id'">
                    <!-- <a :href="props.row.tracking_id.target" target="_blank" >{{ props.row.tracking_id.id }}</a> -->
                    <a href="javascript:void(0);" :id="`popover-${props.row.tracking_id.id}`">{{ props.row.tracking_id.id }}</a>
                    <b-popover :target="`popover-${props.row.tracking_id.id}`" triggers="click blur" placement="right">
                      <b-row class="flex-column">
                        <b-col>
                          <a :href="props.row.tracking_id.target" target="_blank" >Open Link</a>
                        </b-col>
                        <b-col>
                          <a href="javascript:void(0);" @click="copyTrackingID(props.row.tracking_id.id)" >Copy</a>
                        </b-col>
                      </b-row>
                    </b-popover>
                  </span>
                  <span v-else-if="['declared_value', 'rate', 'insurance_price','total_price', 'tracking_price'].includes(props.column.field)">
                    {{ format.price(props.row[props.column.field]) }}
                  </span>
                  <span v-else-if="props.column.field === 'total_weight'">
                    {{getWeight(props.row.total_weight).lb}}lb
                    {{getWeight(props.row.total_weight).oz}}oz
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
              {{ /* VGT */ }}
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.guaranteed-verbage {
  font-style: italic;
  text-align: center;
  color: #606266;
  font-size: 0.875rem;
}
.text-green{
  color: #438b30
}
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  & + .calendar-root {
    .input-date {
      display: none;
    }
    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}
.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }
  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
.row-danger {
  background-color: #f8d7da !important;
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import DateRangePicker from "vue-rangedate-picker";
import { VueGoodTable } from 'vue-good-table';
import VGTMixin from './Mixins/VGTMixins';
import lStore from './Mixins/lStore';
import { mapGetters } from "vuex";
import hash from 'object-hash';
import _ from "lodash";

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    DateRangePicker
  },
  mixins: [VGTMixin],
  // add props orderStatusId -> id & orderType -> name
  data(){
    return {
      selectedClaim: [],
      tab: 'claimable',
      claimable: 0,
      shipments: 0,
      tracking: null,
      selectedColumns: [
        "label_return_status", "status", "created_at",
        "acceptance_date", "delivered_date", "days_in_transit"
      ],
      columns: [
        {
          field: 'id', label: "Claim Submitted",
          thClass:"vgt-headers narrowest",
          sortable: false,
        },
        {
          field: 'marketplace', label: "Marketplace",
          thClass:"vgt-headers narrowest", hidden: true,
        },
        {
          field: 'printed_by', label: "Printed By",
          thClass:"vgt-headers narrower", hidden: true,
        },
        {
          field: 'returned_by', label: "Created By",
          thClass:"vgt-headers narrowest", hidden: true,
        },
        {
          field: 'status', label : "Status",
          thClass:"vgt-headers narrower",
        },
        {
          field: 'created_at', label: "Label Created", type: 'date',
          dateInputFormat: 'yyyy-M-dd HH:mm:ss', 'dateOutputFormat': 'MMM dd yyyy HH:mma',
          thClass:"vgt-headers wide",
        },
        {
          field: 'acceptance_date', label: "Acceptance Date", type: 'date',
          dateInputFormat: 'yyyy-M-dd HH:mm:ss', 'dateOutputFormat': 'MMM dd yyyy HH:mma',
          thClass:"vgt-headers wide",
        },
        {
          field: 'delivered_date', label: "Delivered Date", type: 'date',
          dateInputFormat: 'yyyy-M-dd HH:mm:ss', 'dateOutputFormat': 'MMM dd yyyy HH:mma',
          thClass:"vgt-headers wide",
        },
        {
          field: 'days_in_transit', label : "Days in Transit",
          thClass:"vgt-headers",
        },
        {
          field: 'origin_address', label: "Origin Address",
          thClass:"vgt-headers wider", hidden: true,
        },
        {
          field: 'origin_postal', label: "Origin Postal",
          thClass:"vgt-headers narrow", hidden: true,
        },
        {
          field: 'order_number', label: "Order Number",
          sortable: true, thClass:"vgt-headers narrow", hidden: true,
        },
        {
          field: 'ref_id', label: "Reference ID",
          sortable: false, thClass:"vgt-headers narrow", hidden: true,
        },
        {
          field: 'name', label: "Recipient",
          thClass:"vgt-headers", hidden: true,
        },
        {
          field: 'address', label: "Address",
          thClass:"vgt-headers widest",
          hidden: true,
        },
        {
          field: 'tracking_id', label: "Tracking Number",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'shipping_service', label: "Service Class",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'rate', label: "Shipping Rate",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'package_type', label: "Package Type",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'total_weight', label: "Weight",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'dimension', label: "Dimensions",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'tracking_price', label: "Additional Tracking",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'declared_value', label: "Declared Value",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrow",
        },
        {
          field: 'total_price', label: "Total Cost",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrow",
        },
        {
          field: 'confirmation', label: "Signature",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrowest",
        },
        {
          field: 'label_sticky', label: "Custom Field 1",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'label_sticky_2', label: "Custom Field 2",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'email', label: "Email",
          hidden: true, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'phone', label: "Phone",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'postmark_date', label: "Postmark Date",type: 'date',
          dateInputFormat: 'yyyy-M-dd', 'dateOutputFormat': 'MMM dd yyyy',
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'description', label: "Description",
          sortable: true, hidden: true,
          thClass:"vgt-headers widest",
        },{
          field: 'acct_id', label: "Account ID",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'delivery_zone', label: "Delivery Zone",
          sortable: true, hidden: true,
          thClass:"vgt-headers narrow",
        },{
          field: 'extra_1', label: "Note 1",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_2', label: "Note 2",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_3', label: "Note 3",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_4', label: "Note 4",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_5', label: "Note 5",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      employee_name: "getEmployeeName",
    }),
  },
  async mounted() {
    this.orderType = {
      id: 3,
      name: 'shipaudit',
    };

    this.serverParams = {
      columns: null,
      printed_by: 'all',
      returned_by: 'all',
      voided_by: 'all',
      marketType: 'all',
      dateRange: null,
      searchTerm: '',
      ids: [],
      columnFilters: null,
      sort: null,
      page: 1,
      perPage: 50,
      serviceClass: ['FCM', 'PM'],
      monthsLimit: 3,
      claimable: true,
    };

    const [claimable, shipments] = await Promise.all([
      axios.get('/orders-claimable-count',{
        params: Object.assign({}, this.serverParams, {status: this.orderType.id, with_type: this.orderType.name, claimable: true})
      }),
      axios.get('/orders-shipment-count',{
        params: Object.assign({}, this.serverParams, {status: this.orderType.id, with_type: this.orderType.name, claimable: false})
      }),
    ])

    this.claimable = claimable.data.total;
    this.shipments = shipments.data.total;

    if (claimable) {
      this.$set(this.columns[0], 'hidden', true)
    } else {
      this.$set(this.columns[0], 'hidden', false)
    }

    console.log('orderType', this.orderType);
    const cols = lStore.get(`${this.orderType.name}Columns`);
    if(cols){
      const { columns, selectedColumns } = cols;
      this.columns = columns;
      this.selectedColumns = selectedColumns;
    }
    const pP = lStore.get(`${this.orderType.name}PerPage`);
    if(pP){
      this.serverParams.perPage = pP;
    }
    this.clearSessionAndFetch(this.orderType.name);
  },
  methods: {
    async getOrders(claimable) {
      this.tab = (claimable) ? 'claimable' : 'shipments'

      if (claimable) {
        this.$set(this.columns[0], 'hidden', true)
      } else {
        this.$set(this.columns[0], 'hidden', false)
      }

      const [claim, shipments] = await Promise.all([
        axios.get('/orders-claimable-count',{
          params: Object.assign({}, this.serverParams, {status: this.orderType.id, with_type: this.orderType.name, claimable: true})
        }),
        axios.get('/orders-shipment-count',{
          params: Object.assign({}, this.serverParams, {status: this.orderType.id, with_type: this.orderType.name, claimable: false})
        }),
      ])

      this.claimable = claim.data.total;
      this.shipments = shipments.data.total;

      this.updateVGTParams({
        claimable: claimable,
      });
      this.rows = []
      await this.clearSessionAndFetch(this.orderType.name);
    },
    rowStyleClass(row) {
      // only applies in claimable tab
      return 'row-danger'
      // if (this.getTransitDays(row).day > 3 && !row.label_claimed) {
      //   return 'row-danger'
      // }
    },
    getTransitDays(data) {
      if (data.acceptance_date) {
        const d1 = moment.utc(data.acceptance_date).startOf('day');
        let d2 = moment.utc(data.delivered_date).startOf('day');
        if(!d2.isValid()) d2 = moment.utc().startOf('day');

        const numberOfDays = d2.diff(d1, 'days');
        let totalDays = 0;
        console.log('number of days', numberOfDays);
        for(let i = 0; i < numberOfDays; i++ ){
          const d = d1.clone().add(i+1,'day');
          // if day is sunday/saturday exclude from count
          if(![0,6].includes(d.day())){
            totalDays++;
          }
        }

        // let cName = '';
        // if (businessDays < 4) cName = 'text-green'
        // if (businessDays < 5) cName = 'text-green'

        // return  {day: businessDays, html: `<span class='${cName}'>${businessDays} day(s)</span>`}
        return  {day: totalDays, html: `${totalDays} day(s)`}
      }

      // if (data.acceptance_date) {

      //   const d1 = moment.utc(data.acceptance_date).startOf('day');
      //   let d2 = moment.utc(data.delivered_date).startOf('day');
      //   if(!d2.isValid()) d2 = moment.utc().startOf('day');

      //   // Calc all days used including last day ( the +1 )
      //   const days = d2.diff(d1, 'days');
      //   console.log("DAYS", days);

      //   // how many full weekends occured in this time span
      //   const weekends = Math.floor( days / 7 );

      //   // Subtract all the weekend days
      //   let businessDays = days - ( weekends * 2);

      //   // Special case for weeks less than 7
      //   if( weekends === 0 ){
      //     const cur = d1.clone();
      //     for( let i =0; i < days; i++ ){
      //       if( cur.day() === 0 || cur.day() === 6 ){
      //         businessDays--;
      //       }
      //       cur.add(1, 'days')
      //     }
      //   } else {
      //     // If the last day is a saturday we need to account for it
      //     if (d2.day() === 6 ) {
      //       // console.log('Extra weekend day (Saturday)');
      //       businessDays--;
      //     }
      //     // If the first day is a sunday we need to account for it
      //     if (d1.day() === 0) {
      //       // console.log('Extra weekend day (Sunday)');
      //       businessDays--;
      //     }
      //   }

      //   let cName = '';
      //   if (businessDays < 4) cName = 'text-green'

      //   return  {day: businessDays, html: `<span class='${cName}'>${businessDays} day(s)</span>`}
      // }
      return  {day: '', html: ''}
    },
    checkClaim(data) {
      if (data.label_claimed || data.label_shipped_status === 'delivered') return true;
      const days = this.getTransitDays(data)
      if (days.day > 3) {
        return false
      }
      return true
    },
    async claimLabel(data) {
      console.log('claiming: ', data);
      let dialog = null;
      try {
        const msg = `You are confirming that you have filed this shipment with Pitney Bowes.<br /><br />This action can not be undone.`;
        dialog = await this.$dialog.confirm(msg);
        if(dialog){
          const response = await axios.post(`order-labels/claim/${data.id}`)
          this.clearSessionAndFetch(this.orderType.name);
          await this.fetchOrders();
        }
      } catch (e){
        console.log('claimed label error');
        document.getElementById(`${data.id}-checkbox`).checked = false;

        if(typeof(e) === 'object'){
          let message = e.response.data.message;
          if (e.response.data.errors) {
            message += ": ";
            message += Object.values(e.response.data.errors).join(" ");
          }
          this.$emit("alert", { message: message, type: "danger" });
        }
      } finally {
        if(dialog) dialog.close();
      }
    },
    async hideClaims() {
      let dialog = null;
      try {
        const msg = `You are attempting to delete ${this.serverParams.ids.length} records.&nbsp;&nbsp;This action is irreversible`;
        dialog = await this.$dialog.confirm(msg, {
          view: 'warning',
          customClass: 'warning-dialog',
        });
        if(dialog){
          const response = await axios.post('order-labels/delete', {ids: this.serverParams.ids})
          this.clearSessionAndFetch(this.orderType.name);
        }
      } catch (e){
        if(typeof(e) === 'object'){
          let message = e.response.data.message;
          if (e.response.data.errors) {
            message += ": ";
            message += Object.values(e.response.data.errors).join(" ");
          }
          this.$emit("alert", { message: message, type: "danger" });
        }
      } finally {
        this.serverParams.ids = [];
        await this.fetchOrders();
        if(dialog) dialog.close();
      }
    },
    clickClaim(row) {
      if (this.selectedClaim.includes(row.id)) {
          this.selectedClaim = _.without(this.selectedClaim, row.id)
      } else {
        this.selectedClaim.push(row.id)
      }
    },
    async exportClaim() {
      try{
        //? filter claimable?
        // const msg = `The ${this.serverParams.ids.length} records will be exported to a csv file.  These shipments will be moved to All Shipments tab and marked Claim Submitted.  This action is irreversible.`;
        const msg = `The ${this.serverParams.ids.length} records will be exported to a csv file.  These shipments will be marked Claim Submitted.  This action is irreversible.`;
        if(!Cookies.get(hash(msg))){
          let dialog = await this.$dialog.confirm({ title: 'Export Data', body: msg }, {
            remember: true,
            view: 'print',
            customClass: 'print-dialog',
            proceed: 'Export'
          });
          dialog.close();
        }

        const data = { dateNow: moment().format('MMDDYYYY') }
        const response = await axios.post('/orders/export-claim', data, {
          params: Object.assign({}, {status: this.orderType.id, with_type: this.orderType.name, orderIds: this.serverParams.ids, claim: true}, this.serverParams)
        });
        // console.log('export response', response);
        window.open(response.data.url);
        await this.getOrders(true);
        // await this.clearSessionAndFetch(this.orderType.name);
      } catch(e) {
        console.log(e);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Orders/ShipAudit.vue